module.exports = __webpack_public_path__ + "img/lapper_stikktittel.c390df93.png";